import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { tryAgainChangeMonitoring } from '@api/manageNetworkElementConfigurations';

import { IWithUpdateId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_TRY_AGAIN_CHANGE_MONITORING } from '@constants/queryKeys';

interface IUseMutateChangeMonitoringTryAgainReturned {
	isLoadingTryAgainChangeMonitoring: boolean;
	tryAgainChange: UseMutateAsyncFunction<any, any, IWithUpdateId, any>;
}

const useMutateChangeMonitoringTryAgain = (
	onSuccess?: () => void,
): IUseMutateChangeMonitoringTryAgainReturned => {
	const {
		isLoading,
		mutateAsync,
	} = useMutation<IWithUpdateId>({
		mutationKey: [NETWORK_ELEMENT_TRY_AGAIN_CHANGE_MONITORING],
		mutationFn: tryAgainChangeMonitoring,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess,
	});

	return {
		isLoadingTryAgainChangeMonitoring: isLoading,
		tryAgainChange: mutateAsync,
	};
};

export default useMutateChangeMonitoringTryAgain;
